module.exports = __webpack_public_path__ + "static/img/pop_260210.336b0b55.jpg";